export default __webpack_public_path__ + "static/today_widget-cf306268d040d6654501bcf57859115e.webp";